import type { FunctionComponent } from 'react';
import ConsentLegalDisclaimer from '../../shared/agent-consent/LegalDisclaimer/LegalDisclaimer';
import { useAtlassianBrand } from '../mcpTerminology';
import { mcpLegalDisclaimerMessages } from '../../MCP/LegalDisclaimer/messages';

const LegalDisclaimer: FunctionComponent = () => {
  const product = useAtlassianBrand();

  return (
    <ConsentLegalDisclaimer
      product={product}
      messages={{
        agreementHeader: mcpLegalDisclaimerMessages.agreementHeader,
        agreementLinks: mcpLegalDisclaimerMessages.agreementBulletTwo,
        privacyPolicy: mcpLegalDisclaimerMessages.privacyPolicy,
        termsOfUse: mcpLegalDisclaimerMessages.termsOfUse,
      }}
    />
  );
};

export default LegalDisclaimer;
